export const  sortParentIdComponents = (dataSearch, AllData) =>{
    
        let sortComponents = []
        var emptycomponent = AllData.map(function (eachObject) {
             eachObject.parent_ids.map(function (eachIdofeachComponent) {
                if (eachIdofeachComponent === dataSearch) {
                    sortComponents.push(eachObject)
                    sortComponents.sort((a, b) => (a.order > b.order) ? 1 : -1);
                }
            })
        })
        return sortComponents
    } 

export const sortNoIdComponents = (AllData) =>{
    var emptycomponent = <></>;
    let sortComponents = []
    emptycomponent = AllData.map(eachObject => {
                sortComponents.push(eachObject)
                sortComponents.sort((a, b) => (a.order > b.order) ? 1 : -1);
    })
    return sortComponents
} 